// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordin_contents {
    padding: 60px 0 30px 0;
}

.accordion-contents .r-overflow-1udh08x  {
    height: initial !important;
}`, "",{"version":3,"sources":["webpack://./src/components/accordion/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".accordin_contents {\n    padding: 60px 0 30px 0;\n}\n\n.accordion-contents .r-overflow-1udh08x  {\n    height: initial !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
